import { FetchWelldesignUsersRoutine } from '../redux-routines';

const initialState = {
  isFetching: false,
  data: [],
  error: null
};

export const welldesignUsersListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchWelldesignUsersRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchWelldesignUsersRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchWelldesignUsersRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};